/**
 * Canonical VM0-managed run models and Built-in credit price tiers.
 *
 * Keep this module lightweight so public UI surfaces can read price tier data
 * without importing the full model provider contract schema.
 */
export const SUPPORTED_RUN_MODELS = [
  "claude-fable-5",
  "claude-opus-5",
  "gpt-5.6-sol",
  "gpt-5.6-terra",
  "gpt-5.6-luna",
  "gpt-5.5",
  "claude-opus-4-8",
  "claude-opus-4-7",
  "claude-opus-4-6",
  "claude-sonnet-5",
  "claude-sonnet-4-6",
  "deepseek-v4-flash",
  "kimi-k3",
  "kimi-k2.7-code",
  "MiniMax-M3",
  "glm-5.2",
  "glm-5.1",
  "mimo-v2.5",
  "hy3-preview",
] as const;

export type SupportedRunModel = (typeof SUPPORTED_RUN_MODELS)[number];

export type Vm0ModelPriceTier = "$" | "$$" | "$$$" | "$$$$";

/**
 * User-facing credit cost tier for Built-in model offerings. Only applies to
 * the `vm0` provider type; BYOK providers pay the vendor directly and do not
 * carry a platform tier.
 */
export const VM0_MODEL_PRICE_TIER = Object.freeze<
  Record<SupportedRunModel, Vm0ModelPriceTier>
>({
  "claude-fable-5": "$$$$",
  "claude-opus-5": "$$$",
  "gpt-5.6-sol": "$$$",
  "gpt-5.6-terra": "$$",
  "gpt-5.6-luna": "$",
  "gpt-5.5": "$$$",
  "claude-opus-4-8": "$$$",
  "claude-opus-4-7": "$$$",
  "claude-opus-4-6": "$$$",
  "claude-sonnet-5": "$$",
  "claude-sonnet-4-6": "$$",
  "deepseek-v4-flash": "$",
  "kimi-k3": "$$",
  "kimi-k2.7-code": "$",
  "MiniMax-M3": "$",
  "glm-5.2": "$",
  "glm-5.1": "$",
  "mimo-v2.5": "$",
  "hy3-preview": "$",
});
